import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import btpSvg from '../assets/sap-btp-enterprise-architecture.svg';
import logoSAP      from '../assets/SAP-Partner-Logo.png';
import logoBoomi    from '../assets/boomi-seeklogo.png';
import logoOdoo     from '../assets/odoo_logo.png';
import logoAWS      from '../assets/AWS.png';
import logoMicrosoft from '../assets/microsoft-logo-png-2398.png';
import SERVICES_DATA from '../data/services';
import './Home.css';

/* partner logos are PNG imports — no SVG components needed */

const GlobalDeliveryIcon = () => (
  <svg viewBox="0 0 48 48" width="44" height="44" xmlns="http://www.w3.org/2000/svg" style={{flexShrink:0}}>
    <circle cx="24" cy="24" r="21" fill="none" stroke="#075fbd" strokeWidth="2.2"/>
    <ellipse cx="24" cy="24" rx="9" ry="21" fill="none" stroke="#075fbd" strokeWidth="2.2"/>
    <line x1="3" y1="24" x2="45" y2="24" stroke="#075fbd" strokeWidth="2.2"/>
    <path d="M5 14 Q24 18 43 14" fill="none" stroke="#075fbd" strokeWidth="1.6"/>
    <path d="M5 34 Q24 30 43 34" fill="none" stroke="#075fbd" strokeWidth="1.6"/>
  </svg>
);

const PARTNERS = [
  { src: logoSAP,       alt: 'SAP',       name: 'SAP',         sub: 'Open Ecosystem',    small: true  },
  { src: logoBoomi,     alt: 'Boomi',     name: 'Boomi',       sub: 'Integration Cloud', small: true  },
  { src: logoOdoo,      alt: 'Odoo',      name: 'Odoo',        sub: 'ERP Platform',      small: true  },
  { src: logoAWS,       alt: 'AWS',       name: 'AWS',         sub: 'Partner Network'               },
  { src: logoMicrosoft, alt: 'Microsoft', name: 'Microsoft',   sub: 'Solutions Partner'             },
  { src: null,          alt: '',          name: 'Global Delivery', sub: 'US + India · 24×7'         },
];

const HOME_SERVICE_GRADIENTS = [
  'linear-gradient(135deg,#075fbd,#0db7e8)',
  'linear-gradient(135deg,#22c55e,#0db7e8)',
  'linear-gradient(135deg,#8b5cf6,#ec4899)',
  'linear-gradient(135deg,#f97316,#eab308)',
  'linear-gradient(135deg,#0ea5e9,#6366f1)',
  'linear-gradient(135deg,#0f766e,#0ea5e9)',
];

const HOME_SERVICES = SERVICES_DATA
  .map((service, index) => ({
    ...service,
    gradient: HOME_SERVICE_GRADIENTS[index],
    link: '/services',
  }));

/* ─────────────────────────────────────────
   STATS
───────────────────────────────────────── */
const STATS = [
  {
    value: '250+',
    label: 'Projects Delivered',
    icon: (
      <svg viewBox="0 0 24 24" width="30" height="30" stroke="#7dd3fc" strokeWidth="1.8" fill="none" strokeLinecap="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <circle cx="19" cy="11" r="3"/>
        <path d="M19 8v6M16 11h6"/>
      </svg>
    ),
  },
  {
    value: '100+',
    label: 'Happy Clients',
    icon: (
      <svg viewBox="0 0 24 24" width="30" height="30" stroke="#7dd3fc" strokeWidth="1.8" fill="none" strokeLinecap="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    value: '30+',
    label: 'Expert Consultants',
    icon: (
      <svg viewBox="0 0 24 24" width="30" height="30" stroke="#7dd3fc" strokeWidth="1.8" fill="none" strokeLinecap="round">
        <rect x="3" y="4" width="18" height="18" rx="2"/>
        <path d="M16 2v4M8 2v4M3 10h18"/>
        <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01"/>
      </svg>
    ),
  },
  {
    value: '2',
    label: 'Global Delivery Centers USA & INDIA',
    icon: (
      <svg viewBox="0 0 24 24" width="30" height="30" stroke="#7dd3fc" strokeWidth="1.8" fill="none" strokeLinecap="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20"/>
      </svg>
    ),
  },
  {
    value: '24x7',
    label: 'Support & Operations',
    icon: (
      <svg viewBox="0 0 24 24" width="30" height="30" stroke="#7dd3fc" strokeWidth="1.8" fill="none" strokeLinecap="round">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
  },
];

/* ─────────────────────────────────────────
   INDUSTRY ICONS
───────────────────────────────────────── */
const INDUSTRIES = [
  {
    label: 'Manufacturing',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" stroke="#075fbd" strokeWidth="1.8" fill="none" strokeLinecap="round">
        <path d="M2 20h20"/>
        <path d="M17 20V8l-5 3V8l-5 3V4H2v16"/>
        <rect x="14" y="14" width="2" height="4"/>
        <rect x="9" y="14" width="2" height="4"/>
        <rect x="4" y="14" width="2" height="4"/>
      </svg>
    ),
  },
  {
    label: 'Utilities',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" stroke="#075fbd" strokeWidth="1.8" fill="none" strokeLinecap="round">
        <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z"/>
      </svg>
    ),
  },
  {
    label: 'Retail',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" stroke="#075fbd" strokeWidth="1.8" fill="none" strokeLinecap="round">
        <circle cx="9" cy="21" r="1.5"/>
        <circle cx="18" cy="21" r="1.5"/>
        <path d="M3 4h2l2.4 12.5A2 2 0 0 0 9.4 18H18a2 2 0 0 0 2-1.6L21 8H6"/>
      </svg>
    ),
  },
  {
    label: 'Logistics',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" stroke="#075fbd" strokeWidth="1.8" fill="none" strokeLinecap="round">
        <rect x="1" y="6" width="15" height="11" rx="1"/>
        <path d="M16 10h4l3 4v3h-7V10z"/>
        <circle cx="5.5" cy="18.5" r="1.5"/>
        <circle cx="18.5" cy="18.5" r="1.5"/>
      </svg>
    ),
  },
  {
    label: 'Financial',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" stroke="#075fbd" strokeWidth="1.8" fill="none" strokeLinecap="round">
        <rect x="3" y="10" width="18" height="11" rx="2"/>
        <path d="M7 10V7a5 5 0 0 1 10 0v3"/>
      </svg>
    ),
  },
];

/* ─────────────────────────────────────────
   ACCELERATOR ITEMS
───────────────────────────────────────── */
const ACCEL_LEFT = [
  'SAP BTP Integration Framework',
  'API Governance Toolkit',
];
const ACCEL_RIGHT = [
  'Odoo CRM Templates',
  'Analytics Dashboard Starter Kit',
  'AI-Assisted Migration Utility',
];

/* ─────────────────────────────────────────
   HOME COMPONENT
───────────────────────────────────────── */
const TESTIMONIALS = [
  {
    quote: 'TISSA Technology delivered exceptional integration solutions using SAP BTP. Their expertise, commitment and support helped us achieve our transformation goals.',
    author: 'IT Director, Manufacturing Company',
  },
  {
    quote: 'The Boomi to SAP BTP migration was seamless. TISSA\'s accelerators cut our delivery timeline by more than half and the quality was outstanding.',
    author: 'Head of Architecture, Utilities Group',
  },
  {
    quote: 'Our Odoo CRM went live on time and under budget. The team knew the product inside-out and the automated workflows saved us hundreds of hours a month.',
    author: 'VP Operations, Financial Services Firm',
  },
  {
    quote: 'Power BI dashboards that TISSA built gave our executives real-time visibility for the first time. Decision cycles dropped from days to minutes.',
    author: 'Chief Data Officer, Retail Enterprise',
  },
];

export default function Home() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveTestimonial(i => (i + 1) % TESTIMONIALS.length);
    }, 4500);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-copy">
            <h1>
              Transforming Enterprise{' '}
              <span className="hero-highlight">Integration,<br />ERP & Analytics</span>{' '}
              Landscapes
            </h1>
            <p>
              TISSA Technology helps enterprises modernize SAP, Integration, ERP, and Data
              Platforms using SAP BTP, API-led architecture, cloud-native technologies,
              and AI-driven solutions.
            </p>
            <div className="cta-row">
              <Link className="btn-hero-orange" to="/contact">
                Schedule Consultation <span className="arrow">→</span>
              </Link>
              <Link className="btn-hero-outline" to="/services">
                Explore Services <span className="arrow">→</span>
              </Link>
            </div>
          </div>
          <div className="hero-visual">
            <img src={btpSvg} alt="SAP BTP enterprise architecture diagram" />
          </div>
        </div>
      </section>

      {/* ── PARTNERS STRIP ── */}
      <section className="partners-wrapper">
        <div className="container">
          <div className="partners-strip">
            {PARTNERS.map((p, i) => (
              <div className="partner-cell" key={i}>
                <div className="partner-logo-wrap">
                  {p.src
                    ? <img src={p.src} alt={p.alt} className={`partner-logo-img${p.small ? ' partner-logo-img--small' : ''}`} />
                    : <GlobalDeliveryIcon />}
                </div>
                <div className="partner-name">{p.name}</div>
                <div className="partner-sub">{p.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CORE PRACTICES ── */}
      <section className="section practices-section">
        <div className="container">
          <div className="section-kicker">OUR CORE PRACTICES</div>
          <h2 className="section-title">End-to-End Enterprise Transformation Services</h2>
          <div className="services-row">
            {HOME_SERVICES.map((s, i) => (
              <div className="service-card" key={i}>
                <div className="service-icon" style={{ background: s.gradient }}>
                  {s.icon}
                </div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <Link className="service-link" to={s.link}>→</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS BAND ── */}
      <section className="stats-band">
        <div className="container">
          <div className="stats-row">
            {STATS.map((s, i) => (
              <div className="stat-item" key={i}>
                <div className="stat-icon">{s.icon}</div>
                <div className="stat-value">{s.value}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── THREE COLUMNS ── */}
      <section className="section three-col-section">
        <div className="container three-col-grid">

          {/* Industry Solutions */}
          <div className="three-col">
            <div className="col-kicker">INDUSTRY SOLUTIONS</div>
            <div className="industry-grid">
              {INDUSTRIES.map(({ label, icon }) => (
                <div className="industry-item" key={label}>
                  <div className="industry-icon-box">{icon}</div>
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Accelerators */}
          <div className="three-col">
            <div className="col-kicker">OUR ACCELERATORS</div>
            <div className="accel-two-col">
              <ul className="accel-list">
                {ACCEL_LEFT.map((item, i) => (
                  <li key={i}>
                    <span className="accel-check">
                      <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                        <path d="M1 4l3 3 5-6" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <ul className="accel-list">
                {ACCEL_RIGHT.map((item, i) => (
                  <li key={i}>
                    <span className="accel-check">
                      <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                        <path d="M1 4l3 3 5-6" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Client Success */}
          <div className="three-col">
            <div className="col-kicker">CLIENT SUCCESS</div>
            <div className="testimonial-card" key={activeTestimonial} style={{ animation: 'fadeUp 0.4s ease both' }}>
              <div className="quote-icon">"</div>
              <p>"{TESTIMONIALS[activeTestimonial].quote}"</p>
              <div className="testimonial-author">
                — {TESTIMONIALS[activeTestimonial].author}
              </div>
            </div>
            <div className="testimonial-dots">
              {TESTIMONIALS.map((_, i) => (
                <span
                  key={i}
                  className={`tdot${i === activeTestimonial ? ' active' : ''}`}
                  onClick={() => setActiveTestimonial(i)}
                  style={{ cursor: 'pointer' }}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section className="section section-soft">
        <div className="container">
          <div className="section-kicker">PLATFORM CAPABILITIES</div>
          <h2 className="section-title">Eliminate Brittle Third-Party Integration Scripts</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-card-icon">
                <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#075fbd" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="3"/>
                  <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"/>
                </svg>
              </div>
              <h3>Semantic Schema Matching</h3>
              <p>Our AI system maps incompatible internal enterprise fields to deep target structures automatically, adjusting format variations on the fly.</p>
            </div>
            <div className="feature-card">
              <div className="feature-card-icon">
                <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="23 4 23 10 17 10"/>
                  <polyline points="1 20 1 14 7 14"/>
                  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
                </svg>
              </div>
              <h3>Self-Healing Integration Pipelines</h3>
              <p>If a vendor shifts an endpoint or yields a runtime data error, the engine intercepts the error logs, adjusts the code, and re-executes automatically.</p>
            </div>
            <div className="feature-card">
              <div className="feature-card-icon">
                <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#8b5cf6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                  <path d="M3 9h18M9 21V9"/>
                </svg>
              </div>
              <h3>Collapsible Dashboard Console</h3>
              <p>Monitor live vendor connections, agent reasoning logs, and schema mapping sessions from a unified dark-mode operations console with breadcrumb navigation.</p>
            </div>
            <div className="feature-card">
              <div className="feature-card-icon">
                <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <h3>Compliance-Grade Audit Trail</h3>
              <p>Every AI-driven patch, retry, and field-level transformation is logged with full timestamps and confidence scores — ready for SOC 2 and regulatory review.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA BAND ── */}
      <section className="cta-band">
        <div className="container">
          <h2>Ready to Modernize Your Integration &amp; ERP Landscape?</h2>
          <p>
            Let's discuss your roadmap and identify practical opportunities to improve speed,
            reliability and visibility.
          </p>
          <Link className="btn-hero-orange" to="/contact">Book a Consultation</Link>
        </div>
      </section>
    </>
  );
}
